import { TypeOfLeasing } from '../../../types';
import useSettingsStore from '../../components/fleet-calculator/store/settings-store';
import Fuel from '../../components/fleet-calculator/ui/fuel';
import MarginalTax from '../../components/fleet-calculator/ui/margnial-tax';
import MileageFilter from '../../components/fleet-calculator/ui/milage-filter';
import { filter } from './copy';

export default function Filter() {
  const { updateSettingsStore, firstRent, fuelBenefit, typeOfLeasing } =
    useSettingsStore();

  const handleFuelBenefitChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFuelBenefitValue = e.target.value === 'true';

    updateSettingsStore({
      fuelBenefit: newFuelBenefitValue,
    });
  };

  return (
    <aside className="flex flex-col gap-6">
      <header>
        <h3 className="lg:border-t-2 text-xl pt-4 pb-2 border-black">
          {filter.heading}
        </h3>
        <p className="text-sm">{filter.subHeading}</p>
      </header>
      <div className="flex flex-col gap-2">
        <label htmlFor="type-of-leasing">{filter.typeOfLeasing}</label>
        <select
          onChange={(e) => {
            updateSettingsStore({
              typeOfLeasing: e.target.value as TypeOfLeasing,
            });
          }}
          id="type-of-leasing"
          className="p-4 bg-white rounded-[2px] border border-black ring-dark-blue ring-offset-1 focus-visible:ring-2 transition-shadow focus-visible:outline-none w-full"
          defaultValue={typeOfLeasing}
        >
          <option value={TypeOfLeasing.BUSINESS}>
            {TypeOfLeasing.BUSINESS}
          </option>
          <option value={TypeOfLeasing.FINANCIAL}>
            {TypeOfLeasing.FINANCIAL}
          </option>
        </select>
      </div>
      <MileageFilter />
      <div className="flex flex-col gap-2">
        <label>{filter.elevatedFirstMonthRent.label}</label>
        <label className="flex items-center gap-2">
          <input
            type="checkbox"
            className="ring-dark-blue ring-offset-1 focus-visible:ring-2 transition-shadow focus-within:outline-none"
            id="increased-rent"
            defaultChecked={firstRent}
            onChange={(e) =>
              updateSettingsStore({ firstRent: e.target.checked })
            }
          />
          {filter.elevatedFirstMonthRent.subLabel}
        </label>
      </div>
      <div>
        <label>{filter.fuelBenefit.label}</label>
        <p className="text-sm mb-4">{filter.fuelBenefit.subLabel}</p>

        <div className="flex flex-col gap-2">
          <label htmlFor="fuel_benefit_yes" className="flex gap-2 items-center">
            <input
              type="radio"
              id="fuel_benefit_yes"
              name="fuel_benefit"
              value="true"
              defaultChecked={fuelBenefit === true}
              className="ring-dark-blue ring-offset-1 focus-visible:ring-2 transition-shadow focus-within:outline-none"
              onChange={handleFuelBenefitChange}
            />
            Ja
          </label>

          <label htmlFor="fuel_benefit_no" className="flex gap-2 items-center">
            <input
              type="radio"
              id="fuel_benefit_no"
              name="fuel_benefit"
              value="false"
              defaultChecked={fuelBenefit === false}
              className="ring-dark-blue ring-offset-1 focus-visible:ring-2 transition-shadow focus-within:outline-none"
              onChange={handleFuelBenefitChange}
            />
            Nej
          </label>
        </div>
      </div>
      <Fuel />
      <MarginalTax />
    </aside>
  );
}
